import { useOrganization } from '@components/OrganizationBoundary';
import { DEMO_SUBDOMAIN } from '@config/constants';

export const useIsDemoOrganization = () => {
  const { currentOrganization } = useOrganization(false);

  return currentOrganization?.entity?.subdomain === DEMO_SUBDOMAIN;
};
